angular.module('app.api').factory('GridApi', [
  'api',
  function GridApi(api) {
    const gridApi = {
      createGridFilter: payload => {
        return api.post(`grid-filters`, payload)
      },

      getGridFilterById: id => {
        return api.get(`grid-filters/${id}`)
      },

      updateGridFilterById: (id, payload) => {
        return api.put(`grid-filters/${id}`, payload)
      },
      deleteGridFilterById: id => {
        return api.delete(`grid-filters/${id}`)
      },

      getFiltersByGridId: id => {
        return api.get(`grids/${id}/filters`)
      },

      getSharedFiltersByGridIdAndPrivateFiltersByUserId: (gridId, userId) => {
        return api.get(`grids/${gridId}/filters/users/${userId}`)
      },
      getFiltersByUserId: id => {
        return api.get(`users/${id}/filters`)
      },
      editDefaultGridFilter: (id, payload) => {
        return api.put(`users/${id}/filters`, payload)
      },
    }
    return gridApi
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/directives/ag-grid-listing/ag-grid-listing.api.js